import Vue from 'vue'
import { debounce, range } from 'lodash'
import dayjs from 'dayjs'
//templateTODO: change this based on your default sort
  const searchSortByDefault = 'ID'
const project= {
  state: {
    searchTotal: 0,
    searchPage: 1,
    searchSortBy: searchSortByDefault,
    searchDescending: true,
    searchRowsPerPage: 25,
    searchText: '',
    searchDivision: [],
    lookupText: '',
    //templateTODO: uncomment as used in ProjectSearchParams
    searchStartDate: dayjs()
        .subtract(1, 'month')
        .format('YYYY-MM-DD'),
    searchEndDate: dayjs().format('YYYY-MM-DD'),
    // searchAddToWolfs: [],
    // searchShowInactive: false,
    // searchIsActive: [],
    // searchIsApproved: [],
  },

  getters: {
    searchParameters(state) {
      return {
        pageNum: state.searchPage - 1,
        pageSize: state.searchRowsPerPage,
        sortProperty: state.searchSortBy,
        sortDirection: state.searchDescending ? 'desc' : 'asc',
        searchText: state.searchText,
        searchDivision: state.searchDivision,
        //templateTODO: uncomment as used in ProjectSearchParams
        //startDate: state.searchStartDate,
        //endDate: state.searchEndDate,
            //addToWolfs: state.searchAddToWolfs,
            // showInactive: state.searchShowInactive,
            //isActive: state.searchIsActive,
            //isApproved: state.searchIsApproved,
      }
    },
  },

  mutations: {
    searchTotal(state, payload) {
      state.searchTotal = payload
    },
    searchPage(state, payload) {
      state.searchPage = payload
    },
    searchSortBy(state, payload) {
      state.searchSortBy = payload
    },
    searchDescending(state, payload) {
      state.searchDescending = payload
    },
    searchRowsPerPage(state, payload) {
      state.searchRowsPerPage = payload
    },
    searchText(state, payload) {
      state.searchText = payload
    },
    searchDivision(state, payload) {
      state.searchDivision = payload
    },
    lookupText(state, payload) {
      state.lookupText = payload
    },
    //TemplateTODO: uncomment as needed
    //searchStartDate(state, payload) {
    //  state.searchStartDate = payload
    //},
    //searchEndDate(state, payload) {
    //  state.searchEndDate = payload
    //},
    //searchAddToWolfs(state, payload) {
    //  state.searchAddToWolfs = payload
    //},
    //searchShowInactive(state, payload) {
    //  state.searchShowInactive = payload
    //},
    //searchIsActive(state, payload) {
    //  state.searchIsActive = payload
    //},
    //searchIsApproved(state, payload) {
    //  state.searchIsApproved = payload
    //},
  },

  actions: {
    lookupBounce: _.debounce((context) => {
      context.dispatch('lookupProject')
    }, 300),
    searchBounce: _.debounce((context) => {
      context.dispatch('searchProject')
    }, 750),
    setSearchPage(context, payload) {
      if (payload != context.state.searchPage) {
        context.commit('searchPage', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchSortBy(context, payload) {
      if (payload != context.state.searchSortBy) {
        context.commit('searchSortBy', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchDescending(context, payload) {
      if (payload != context.state.searchDescending) {
        context.commit('searchDescending', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchRowsPerPage(context, payload) {
      if (payload != context.state.searchRowsPerPage) {
        context.commit('searchRowsPerPage', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchText(context, payload) {
      if (payload != context.state.searchText) {
        context.commit('searchText', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchDivision(context, payload) {
      if (payload != context.state.searchDivision) {
        context.commit('searchDivision', payload)
        context.dispatch('lookupBounce', context)
      }
    },
    setLookupText(context, payload) {
      if (payload != context.state.lookupText && payload != null) {
        context.commit('lookupText', payload)
        context.dispatch('lookupBounce', context)
      }
    },
    //TemplateTODO: uncomment as needed
    setSearchStartDate(context, payload) {
      if (payload != context.state.searchStartDate) {
        context.commit('searchStartDate', payload)
        context.dispatch('searchBounce', context)
      }
    },
    setSearchEndDate(context, payload) {
      if (payload != context.state.searchEndDate) {
        context.commit('searchEndDate', payload)
        context.dispatch('searchBounce', context)
      }
    },
    //setSearchAddToWolfs(context, payload) {
    //  if (payload != context.state.searchAddToWolfs) {
    //    context.commit('searchAddToWolfs', payload)
    //    context.dispatch('searchBounce', context)
    //  }
    //},
    //setSearchShowInactive(context, payload) {
    //  if (payload != context.state.searchShowInactive) {
    //    context.commit('searchShowInactive', payload)
    //    context.dispatch('searchBounce', context)
    //  }
    //},
    //setSearchIsActive(context, payload) {
    //  if (payload != context.state.searchIsActive) {
    //    context.commit('searchIsActive', payload)
    //    context.dispatch('searchBounce', context)
    //  }
    //},
    //setSearchIsApproved(context, payload) {
    //  if (payload != context.state.searchIsApproved) {
    //    context.commit('searchIsApproved', payload)
    //    context.dispatch('searchBounce', context)
    //  }
    //},
    searchProject(context, payload) {
      return new Promise((resolve, reject) => {
        if (!context.state.searchSortBy) {
            context.commit('searchSortBy', searchSortByDefault)
            context.commit('searchDescending', true)
        }
        if (Array.isArray(context.state.searchSortBy)) {
          if (context.state.searchSortBy.length > 0) {
              context.commit('searchSortBy', context.state.searchSortBy[0])
              context.commit(
              'searchDescending',
              context.state.searchDescending[0]
            )
          } else {
              context.commit('searchSortBy', searchSortByDefault)
              context.commit('searchDescending', true)
          }
        }
        if (!context.state.searchText) {
            context.commit('searchText', '')
        }
        context.commit('increaseSearchCount')
        var params = context.getters.searchParameters
        var paramString = JSON.stringify(params)
        const url = `Project/Search`
        Vue.prototype.$axios.post(url, params).then(
          (res) => {
            if (JSON.stringify(context.getters.searchParameters) == paramString) {
            context.commit('project', res.data.Entries)
            context.commit('searchRowsPerPage', res.data.Page.Size)
            context.commit('searchPage', res.data.Page.Number + 1)
            context.commit('searchTotal', res.data.Page.TotalElements)
            }
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            context.commit('decreaseSearchCount')
            reject(err)
          }
        )
      })
    },
    lookupProject(context, payload) {
      if (context.state.lookupText) {
        return new Promise((resolve, reject) => {
          context.commit('increaseSearchCount')
          const url = `Project/Lookup?search=${JSON.stringify({searchText: context.state.lookupText, division: context.state.searchDivision})}`
          Vue.prototype.$axios.get(url).then(
            (res) => {
              context.commit('project', res.data)
              context.commit('decreaseSearchCount')
              resolve(res)
            },
            (err) => {
              console.error(err)
              context.dispatch('errors/handleError', err, { root: true })
              context.commit('decreaseSearchCount')
              reject(err)
            }
          )
        })
      }
    },
  },
}

export default
project